import { Box, CircularProgress, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { modernTableContainer } from '../../styles';

function EmptyTable(props) {
  const { t } = useTranslation();

  return (
    <Box style={modernTableContainer}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="400px"
      >
        <Typography
          style={{
            padding: '2rem',
            fontWeight: '500',
            color: '#64748b',
            fontSize: '1.1rem',
          }}
        >
          {props.isLoading ? <CircularProgress /> : t('No_result_found')}
        </Typography>
      </Box>
    </Box>
  );
}

export default EmptyTable;
